import { ID_REGEX } from "@/constants";

export const isNotId = (value: string) => {
  return value.match(ID_REGEX) === null;
};
